module.exports = __webpack_public_path__ + "static/arrow-blue-000af7f1a3101af55105e7a867e3b70f.png";